import React, { useContext } from 'react';
import Link from '@discover-ui/link';
import { countFormat, roundToClosest } from '@discover-lib/dataFormats';
import SilverstripeContext from '@/components/context/Silverstripe';

const questions = (dinerCount: number, restaurantCount: number) => [
  {
    question: 'Will my booking be honoured?',
    answer: "Yes! Your reservation is confirmed instantly and the restaurant knows you're coming.",
  },
  {
    question: 'Do restaurants limit what I can order?',
    answer:
      'The menu and any conditions are always clear upfront, so you know exactly what to expect.',
  },
  {
    question: 'Is First Table legit?',
    answer: `Trusted by over ${countFormat(roundToClosest(Math.max(500000, dinerCount), 100000))} diners and ${countFormat(roundToClosest(restaurantCount, 100))}+ restaurants globally. We monitor restaurant quality and only work with reputable venues. `,
  },
];

const HowItWorksQuestions = () => {
  const { global: { siteConfig } = { siteConfig: null } } = useContext(SilverstripeContext);
  const dinerCount = siteConfig?.dinerCount ?? 0;
  const restaurantCount = siteConfig?.restaurantCount ?? 0;

  return (
    <>
      <h3 className="mb-6 font-serif text-lg text-brand-blue sm:text-xl">Common Questions</h3>

      {questions(dinerCount, restaurantCount).map((item) => (
        <div key={item.question} className="mb-6">
          <p className="text-base font-bold leading-normal sm:text-[19px]">{item.question}</p>
          <p className="text-sm sm:text-base">{item.answer}</p>
        </div>
      ))}

      <div className="mx-0.5 mt-2 sm:flex sm:justify-start">
        <Link kind="outline" href="/frequently-asked-questions" className="py-2">
          See all FAQs
        </Link>
      </div>
    </>
  );
};

export default HowItWorksQuestions;
